import React from "react";
import PropTypes from "prop-types";

import { Modal, Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

const ConfirmModal = ({
  open,
  onCloseModal,
  modalText,
  okayText,
  cancelText,
  onOkayClick,
  success = false,
  isLoading = false,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 4,
  };
  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <MDTypography id="modal-modal-title" variant="h4" component="h2">
          {modalText}
        </MDTypography>
        <MDBox align="right" marginTop="32px">
          <MDButton
            disabled={isLoading}
            isLoading={isLoading}
            onClick={onOkayClick}
            color={success ? "success" : "error"}>
            {okayText}
          </MDButton>
          <MDButton onClick={onCloseModal}>{cancelText}</MDButton>
        </MDBox>
      </Box>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  onCloseModal: PropTypes.func,
  modalText: PropTypes.string,
  okayText: PropTypes.string,
  cancelText: PropTypes.string,
  onOkayClick: PropTypes.func,
};

ConfirmModal.defaultProps = {
  open: false,
  onCloseModal: () => {},
  modalText: "",
  okayText: "Yes",
  cancelText: "Cancel",
  onOkayClick: () => {},
};

export default ConfirmModal;
